import { Chip } from '@mui/material';
import React from 'react';
import { P, match } from 'ts-pattern';
import TablerIconZoomCode from '~icons/tabler/zoom-code';
import { FilePathTruncate } from '#/components/Utils';
import { GitHubFileIcon } from '../../github/components/Icons/GitHubFileIcon';
import ChatMessagePartToolContainer from './chat-message-part-tool-container';
import type { ChatMessagePartToolBaseProps } from './types';

export type ChatMessagePartToolGitHubSearchCodeProps =
  ChatMessagePartToolBaseProps<'github-search-code'>;

function ChatMessagePartToolGitHubSearchCode({
  toolInvocation,
  compact,
  defaultOpen,
  card,
  onEngage,
}: ChatMessagePartToolGitHubSearchCodeProps) {
  return match(toolInvocation)
    .with(
      { state: 'result', result: { status: 'success' } },
      ({ result: { result } }) => {
        return (
          <ChatMessagePartToolContainer
            icon={<TablerIconZoomCode />}
            title={`Found ${result.length} files`}
            status='result'
            compact={compact}
            defaultOpen={defaultOpen}
            card={card}
            onToggle={() => {
              onEngage?.('engage');
            }}
            items={result.map((file) => ({
              icon: (
                <GitHubFileIcon
                  fileExtension={`${file.path}`.split('.').pop()}
                />
              ),
              title: (
                <code className='text-sm rounded-sm font-mono py-0.5 px-2 bg-black/30 text-primary-main'>
                  <FilePathTruncate filePath={file.path} />
                </code>
              ),
              action: (
                <Chip
                  size='xsmall'
                  shape='rounded'
                  label={file.repository.name}
                />
              ),
              href: file.url,
              onClick: () => onEngage?.('engage'),
            }))}
          />
        );
      }
    )
    .with({ state: 'result', result: { status: 'error' } }, () => null)
    .otherwise(() => {
      return (
        <ChatMessagePartToolContainer
          icon={<TablerIconZoomCode />}
          card={card}
          title='Searching code in GitHub...'
          status='loading'
        />
      );
    });
}

export default React.memo(ChatMessagePartToolGitHubSearchCode);
